import React, { useState, useEffect, useContext } from 'react';
import { ContextSession } from '../../../services/ContextSession';
import { Box, Table, TableHead, TableRow, TableCell, TableBody, InputLabel, Typography, Container, Stack, Grid, RadioGroup, FormControlLabel, Radio, FormControl, Divider, TextField, Button, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import CheckCircle from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import { useNavigate } from 'react-router-dom';
import html2pdf from 'html2pdf.js'; // Asegúrate de tener html2pdf.js instalado
import imagen from '../../../img/injupemplogogobierno.png'
import logoGobierno from '../../../img/injupemplogogobierno.png';

function VerQuejasSugerencias() {
    let sessi = useContext(ContextSession);
    const [tipoSeleccionado, setTipoSeleccionado] = useState('');
    const [ocultarTextField, setocultarTextField] = useState(true);
    const [correlativo, setCorrelativo] = useState('');
    const [nombre, setNombre] = useState('');
    const [identidad, setIdentidad] = useState('');
    const [correo, setCorreo] = useState('');
    const [telefono, setTelefono] = useState('');
    const [fecharegistro, setFechaRegistro] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [notaRevision, setNotaRevision] = useState('');
    const [loading, setLoading] = useState(false);
    const [estado, setEstado] = useState('');
    const [dialogOpen, setDialogOpen] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        async function fetchData() {
            //console.log("LA DATA DESDE QUEJAS ES:", sessi.sessionData);
            setLoading(true);
            try {
                let sid = sessi.getVariable("IDquejasugerencia");
                const response = await fetch(`https://be.injupemp.gob.hn:8443/api/quejasSugerencias/${sid}/`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                const data = await response.json();
               // console.log(data);

                // Actualiza los valores en el formulario
                setEstado(data.estado);
                setNombre(data.nombre_participante);
                setIdentidad(data.DNI_participante);
                setCorreo(data.correo_participante);
                setTelefono(data.telefono_participante);
                setCorrelativo(data.numerocorrelativo);
                setDescripcion(data.descripcion);
                setTipoSeleccionado(data.tipo === 1 ? 'Queja' : 'Sugerencia');

                // Si el estado es "Cerrado", hacer el campo de Nota de revisión solo lectura y establecer el valor
                if (data.estado === 'Cerrado') {
                    setNotaRevision(data.descripcioncierre);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        }
        fetchData();
    }, [sessi]);

    const handleCloseCase = async () => {
        if (notaRevision.trim() === '') {
            alert("El campo 'Nota de revisión' no puede estar vacío.");
            return;
        }

        try {
            let sid = sessi.getVariable("IDquejasugerencia");
            const formData = new FormData();
            formData.append('idusuarioempleado', sessi.sessionData.id);
            formData.append('descripcioncierre', notaRevision);
            formData.append('fechacierre', new Date().toISOString());
            formData.append('estado', 'Cerrado');

            const response = await fetch(`https://be.injupemp.gob.hn:8443/api/quejasSugerencias/${sid}/`, {
                method: 'PATCH',
                body: formData
            });

            if (response.ok) {
                setDialogOpen(true);
            } else {
                console.error("Error al cerrar el caso");
            }
        } catch (error) {
            console.error("Error al enviar la solicitud:", error);
        }
    };

    const handleDialogClose = () => {
        setDialogOpen(false);
        navigate('/PortalDelParticipante/ListaQuejasSugerencias');
    };

    const handlePrint = () => {
        const element = document.getElementById('printableArea');
        const options = {
            margin: 0.5,
            filename: `${correlativo}.pdf`,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
        };

        html2pdf().set(options).from(element).save();
    };

    const handlePrint2 = () => {
        // Crear el HTML dinámico con los datos
        const contentHTML = `
        <div style="text-align: center; font-family: Arial, sans-serif;">
            <img src="${imagen}" alt="Logo Injupemp" style="max-width: 200px; margin-bottom: 5px;">
            <h2>Quejas y Sugerencias</h2>
            <h2>${correlativo}</h2>
        </div>
            <div style="margin-top: 20px; text-align: center; font-family: Arial, sans-serif;">
                <h2>Estado: ${estado}</h2>
            </div>
            <table style="width: 100%; margin-top: 20px; border-collapse: collapse; font-family: Arial, sans-serif;">
                <thead>
                    <tr>
                        <th style="border: 1px solid black; padding: 8px; text-align: center;">Nombre</th>
                        <th style="border: 1px solid black; padding: 8px; text-align: center;">Identidad</th>
                        <th style="border: 1px solid black; padding: 8px; text-align: center;">Correo</th>
                        <th style="border: 1px solid black; padding: 8px; text-align: center;">Teléfono</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td style="border: 1px solid black; padding: 8px; text-align: center;">${nombre}</td>
                        <td style="border: 1px solid black; padding: 8px; text-align: center;">${identidad}</td>
                        <td style="border: 1px solid black; padding: 8px; text-align: center;">${correo}</td>
                        <td style="border: 1px solid black; padding: 8px; text-align: center;">${telefono}</td>
                    </tr>
                </tbody>
            </table>
            <div style="margin-top: 20px; font-family: Arial, sans-serif;">
                <h3>Tipo Seleccionado: ${tipoSeleccionado}</h3>
                <h3>Descripción: </h3>
                <p style="white-space: pre-wrap; word-wrap: break-word;">${descripcion}</p>
            </div>
            <div style="margin-top: 20px; font-family: Arial, sans-serif;">
                <h3>Nota de Revisión: </h3>
                <p style="white-space: pre-wrap; word-wrap: break-word;">${notaRevision}</p>
            </div>
        `;

        // Crear un contenedor temporal para el HTML
        const element = document.createElement('div');
        element.innerHTML = contentHTML;

        // Establecer opciones para el PDF
        const options = {
            margin: 0.5,
            filename: `${correlativo}.pdf`,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
        };

        // Generar el PDF a partir del HTML creado
        html2pdf().set(options).from(element).save();
    };


    return (
        <>
            <Container id="printableArea" style={{ marginTop: 1 }}>
                <Grid item>
                    <h3 style={{ textAlign: 'center' }}>UDI-F-01.1</h3>
                    <h1 style={{ textAlign: 'center' }}>Quejas y Sugerencias</h1>
                    <h1 style={{ textAlign: 'center' }}>{correlativo}</h1>
                </Grid>


                <Grid
                    item
                    container
                    alignItems="center"
                    justifyContent="center"
                    marginTop={3}
                    spacing={1}
                >
                    {estado === "Cerrado" ? (
                        <Typography variant="h6" style={{ color: 'green', display: 'flex', alignItems: 'center' }}>
                            <InputLabel><b>Estado:</b> </InputLabel>
                            <CheckCircle fontSize="small" style={{ marginLeft: 4, marginRight: 4 }} />
                            {estado}
                        </Typography>
                    ) : estado === "Pendiente" ? (
                        <Typography variant="h6" style={{ display: 'flex', alignItems: 'center', color: 'orange' }}>
                            <InputLabel><b>Estado:</b> </InputLabel>
                            <WarningIcon fontSize="small" style={{ marginLeft: 4, marginRight: 4 }} />
                            {estado}
                        </Typography>
                    ) : null}
                </Grid>
                <Divider />

                <Stack direction="column" alignItems="center" marginTop={1}>
                    <Grid item xs={12}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ backgroundColor: '#f0f0f0', color: 'black', textAlign: 'center' }}>
                                        <b>Nombre</b>
                                    </TableCell>
                                    <TableCell style={{ backgroundColor: '#f0f0f0', color: 'black', textAlign: 'center' }}>
                                        <b>Identidad</b>
                                    </TableCell>
                                    <TableCell style={{ backgroundColor: '#f0f0f0', color: 'black', textAlign: 'center' }}>
                                        <b> Correo</b>
                                    </TableCell>
                                    <TableCell style={{ backgroundColor: '#f0f0f0', color: 'black', textAlign: 'center' }}>
                                        <b> Teléfono</b>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell style={{ backgroundColor: 'white', textAlign: 'center' }}>
                                        {nombre}
                                    </TableCell>
                                    <TableCell style={{ backgroundColor: 'white', textAlign: 'center' }}>
                                        {identidad}
                                    </TableCell>
                                    <TableCell style={{ backgroundColor: 'white', textAlign: 'center' }}>
                                        {correo}
                                    </TableCell>
                                    <TableCell style={{ backgroundColor: 'white', textAlign: 'center' }}>
                                        {telefono}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </Grid>
                    <Stack direction="row" alignItems="center" spacing={2}>
                        <label>TIPO SELECCIONADO:</label>
                        <FormControl component="fieldset">
                            <RadioGroup
                                id="grupoTipoPrestamo"
                                value={tipoSeleccionado}
                                row
                                aria-labelledby="Tipo Prestamo"
                                name="tipoPrestamo"
                            >
                                <FormControlLabel value="Queja" control={<Radio color="error" />} label="Queja" readOnly />
                                <FormControlLabel value="Sugerencia" control={<Radio color="error" />} label="Sugerencia" readOnly />
                            </RadioGroup>
                        </FormControl>
                    </Stack>

                    <TextField
                        label="Descripción:"
                        multiline
                        rows={4}
                        variant="filled"
                        fullWidth
                        style={{ marginTop: 10 }}
                        value={descripcion}
                        inputProps={{ readOnly: true }}
                    />
                </Stack>

                <Divider style={{ marginTop: 20 }} />
                {ocultarTextField && (
                    <Stack direction="column" alignItems="center" spacing={2} marginTop={1}>
                        <TextField
                            label="Nota de revisión"
                            multiline
                            rows={4}
                            variant={estado === "Cerrado" ? "filled" : "outlined"}
                            fullWidth
                            style={{ marginTop: 20 }}
                            value={notaRevision}
                            onChange={(e) => setNotaRevision(e.target.value)}
                            inputProps={{ readOnly: estado === "Cerrado" }}
                        />

                    </Stack>
                )}

            </Container>

            <Stack direction="column" alignItems="center" spacing={2} marginTop={1}>


                {estado !== "Cerrado" && (
                    <>
                        <div style={{ display: "flex", gap: "10px", marginTop: 15 }}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handlePrint2}
                            >
                                Imprimir Caso
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                disabled={loading}
                                onClick={handleCloseCase}
                            >
                                Cerrar Caso
                            </Button>
                        </div>
                    </>
                )}


                {estado === "Cerrado" && (
                    <Container style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginTop: 20 }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handlePrint2}
                            style={{ width: '200px', height: '50px' }}
                        >
                            Imprimir
                        </Button>
                    </Container>)}
            </Stack>
            <Dialog open={dialogOpen} onClose={handleDialogClose}>
                <DialogTitle>Datos Enviados</DialogTitle>
                <DialogContent>
                    La solicitud fue cerrada con éxito.
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose} color="primary">
                        Aceptar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default VerQuejasSugerencias;
